// extracted by mini-css-extract-plugin
module.exports = {"error":"error_error__no4B_","left":"error_left__E_cZU","right":"error_right__MgZMx","center":"error_center__TwPvw","justyfy":"error_justyfy__n3xzH"};